import { useEffect, useState } from "react";
import { getLoggedinUser, getAuthToken, setAuthorization } from "./api_helper_custom";

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  const authToken = getAuthToken();

  var tokenbool = userProfileSession && authToken;
  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    const authToken = getAuthToken();
    var token = userProfileSession && authToken;
    setUserProfile(userProfileSession ? userProfileSession : null);
    setLoading(token ? false : true);
  }, []);


  return { userProfile, loading, tokenbool, authToken };
};

export { useProfile };